'use client';

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, domAnimation, LazyMotion, type Variants } from 'motion/react';
import * as m from 'motion/react-m';
import { useRef, useState } from 'react';
import { useInView } from '@/app/hooks/useInView';
import { LuckyDrawStickyMenuButton } from '@/app/lcv/components/campaigns/floating-button/sticky-menu';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
const fadeVariants: Variants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: 'easeInOut'
    }
  }
};
const slideVariants: Variants = {
  hidden: {
    x: '100%'
  },
  visible: {
    x: 0,
    transition: {
      duration: 0.3,
      ease: 'easeOut'
    }
  }
};
let isFloatingClosed = false;
interface FloatingButtonProps {
  className?: string;
  offsetY?: string;
}
export const FloatingButton = t0 => {
  const $ = _c(10);
  const {
    className,
    offsetY: t1
  } = t0;
  const offsetY = t1 === undefined ? "50%" : t1;
  const [isHide, setIsHide] = useState(isFloatingClosed);
  const scrollTriggerRef = useRef(null);
  const t2 = `${offsetY} 0px 0px 0px`;
  let t3;
  if ($[0] !== t2) {
    t3 = {
      rootMargin: t2,
      initialState: true,
      once: false
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isScrollTriggerInView = useInView(scrollTriggerRef, t3);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      isFloatingClosed = true;
      setIsHide(true);
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const onClose = t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div data-myi-hide={true} ref={scrollTriggerRef} className="pointer-events-none absolute top-px" aria-hidden="true" />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== className || $[5] !== isHide || $[6] !== isScrollTriggerInView) {
    t6 = !isHide && <m.div className={cn("center-x consent-open:bottom-[calc(var(--consent-popup-height)+(--spacing(8)))] md:consent-open:bottom-4 pointer-events-none fixed bottom-4 z-30 w-full px-4 md:px-6", className)} variants={fadeVariants} initial="hidden" animate="visible" exit="hidden" {...createDataAttributes({
      test: "floating-button"
    })}><m.div className={cn("property-opacity-translate ml-auto w-max duration-500 ease-in-out", {
        "translate-x-full opacity-0 *:pointer-events-none": isScrollTriggerInView
      })} variants={slideVariants} {...createDataAttributes({
        test: "content"
      })}><LuckyDrawStickyMenuButton onClose={onClose} /></m.div></m.div>;
    $[4] = className;
    $[5] = isHide;
    $[6] = isScrollTriggerInView;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <>{t5}<LazyMotion features={domAnimation}><AnimatePresence>{t6}</AnimatePresence></LazyMotion></>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};